import React, {useState, useRef} from 'react';
import {Overlay} from 'react-bootstrap';
import '../../../assests/css/tooltip.scss';

export interface tooltipProps {
    text: string,
    children: React.ReactNode,
    customClass?: string,
}

export default function Tooltip(props: tooltipProps) {

    const {text, children, customClass}=props;

    const [
        showMenu,
        setShowMenu,
    ] = useState<boolean>(false);
    const targetRef = useRef(null);

    const handleShowMenu = (value: boolean) => {
        setShowMenu(value);
    };

    return (
        <>
            <div
                ref={targetRef}
                onMouseEnter={() => handleShowMenu(true)}
                onMouseLeave={() => handleShowMenu(false)}
                className={customClass}
            >
                {children}
            </div>
            <Overlay
                target={targetRef.current}
                show={showMenu}
                rootClose={true}
                placement='top'
                rootCloseEvent='mousedown'
                onHide={() => handleShowMenu(false)}
            >
                {({
                    placement: _placement,
                    arrowProps: _arrowProps,
                    show: _show,
                    popper: _popper,
                    hasDoneInitialMeasure: _hasDoneInitialMeasure,
                    ...props
                }) => (
                    <div {...props}>
                        {text.length ?
                        <div className="tooltip-container">
                            <span className="tooltip-text">{text}</span>
                        </div> : null}
                    </div>
                )}
            </Overlay>
        </>
    );

}